import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { RouteRefusal } from '../lib/route-refusal';
import { who } from './ModelSaveNotice';
import { Button } from './ui/Button';

// The Advanced drawer's mode refusal notice (#5211 AC2) — `ModeSaves`'s own:
// just the server's own reason, inline, never swallowed, no cure offered
// (a mode write's refusal has none to give — `agent-mode-save.ts`'s Undo is a
// TOAST action on a SUCCESSFUL save, not a retry on a refused one). `who()` is
// `ModelSaveNotice`'s own mapping, reused rather than copied — the SAME
// sentence names a stale winner everywhere on this page.
//
// ROUND 3 (#5381): a repo-pin refusal (`RepoRouteSaves`) moved OFF this
// component and onto `ModelSaveNotice` — it now answers a `PendingRefusal`
// (the org picker's own shape) and gets the SAME cures ("Apply mine anyway",
// "Apply and reset thinking depth"), never this component's lesser, cure-less
// notice.

function noticeText(refusal: RouteRefusal): string {
  switch (refusal.kind) {
    case 'account_changed':
      return t('agents.save.account_changed');
    case 'stale':
      return refusal.cleared
        ? t('agents.save.stale_cleared', { who: who(refusal.who) })
        : t('agents.save.stale', { who: who(refusal.who) });
    case 'locked':
      return t('agents.save.locked');
    case 'reasoning':
      return refusal.detail;
    case 'refused':
    case 'failed':
      return refusal.detail ?? t('agents.save.failed');
  }
}

export function RouteRefusalNotice(props: {
  readonly refusal: RouteRefusal | null;
  readonly onDismiss: () => void;
}): JSX.Element {
  return (
    <Show when={props.refusal}>
      {(refusal) => (
        <div class="model-save-notice" role="alert" data-refusal={refusal().kind}>
          <p class="model-save-notice__text">{noticeText(refusal())}</p>
          <Button size="sm" variant="ghost" onClick={props.onDismiss}>
            {t('agents.save.dismiss')}
          </Button>
        </div>
      )}
    </Show>
  );
}
